import CashBookHandler from './CashBookHandler'
import { isRouteDisabled } from 'sections/utils'
import { CashBook } from 'media/icons'

export default (t, rights) => ({
	label: t('cash_book_section.caption'),
	typename: 'CashBook',
	link: isRouteDisabled(rights, '15') ? null : 'kassenbuch',
	linkDisabled: isRouteDisabled(rights, '15'),
	handler: CashBookHandler,
	icon: CashBook
})
